import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ApiService } from "../../common/api.service";
import { ROUTES } from "../server-routes";

@Injectable({
  providedIn: 'root',
})
export class PhilMetaService extends ApiService {
  public getDepositTypes(): Observable<any> {
    return this.get<any>(ROUTES.GET_PHIL_DEPOSIT_CODES);
  }
  public getPaymentTiming(): Observable<any> {
    return this.get<any>(ROUTES.PAYMENT_TIMING);
  }
  public getObjectSpecifications(): Observable<any> {
    return this.get<any>(ROUTES.GET_OBJECT_SPECIFICATION);
  }

  public getAllBanks(type: string): Observable<any> {
    return this.get<any>(ROUTES.GET_ALL_BANKS, {
      params: {
        t: type,
      },
    });
  }

  public getUserInfo(paramObj: any): Observable<any> {
    return this.get<any>(ROUTES.USER_INFO, {
      params: paramObj
    });
  }

  public updateUserContact(payload: any): Observable<any> {
    return this.post<any>(ROUTES.UPDATE_USER_CONTACT, {
      body: payload
    });
  }

  public getMagazineTiming(): Observable<any> {
    return this.get<any>(ROUTES.MAGAZINE_TIMING);
  }
  public saveTaxClaimDetails(payload: any): Observable<any> {
    return this.post<any>(ROUTES.TAX_CLAIM, {
      body: payload,

    });
  }
  public fetchTaxClaimedDetails(): Observable<any> {
    return this.get<any>(ROUTES.TAX_CLAIMED_DETAILS)
  }
}